export default "__VITE_ASSET__c951SW1Q__"